import React from "react";

const SvgArticle = props => (
  <svg width="1em" height="1em" viewBox="0 0 986.8 986.8" {...props}>
    <path fill="#cccccc" d="M399.8 164.649H110.5c-22.1 0-40 17.9-40 40s17.9 40 40 40h289.3c22.101 0 40-17.9 40-40 0-22.099-17.9-40-40-40zM399.8 450.85H206.5c-22.1 0-40 17.9-40 40 0 22.099 17.9 40 40 40h193.3c22.101 0 40-17.9 40-40s-17.9-40-40-40zM399.8 307.75H40c-22.1 0-40 17.9-40 40s17.9 40 40 40h359.8c22.101 0 40-17.9 40-40s-17.9-40-40-40zM399.8 594.05H40c-22.1 0-40 17.898-40 40 0 22.1 17.9 40 40 40h359.8c22.101 0 40-17.9 40-40 0-22.101-17.9-40-40-40zM399.8 737.15H40c-22.1 0-40 17.9-40 40s17.9 40 40 40h359.8c22.101 0 40-17.9 40-40s-17.9-40-40-40zM926.8 160.25H572.4c-33.101 0-60 26.9-60 60v546.3c0 33.1 26.899 60 60 60h354.4c33.101 0 60-26.9 60-60v-546.3c0-33.2-26.8-60-60-60z" />
  </svg>
);

export default SvgArticle;
